// extracted by mini-css-extract-plugin
export default {"container":"Zaglavlje_container__CCWdA"};